import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ProviderTokenSlot, ProviderTokenUpsertRequest, ProviderType } from '../models/provider-token.model';

@Injectable({ providedIn: 'root' })
export class ProviderTokenService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/api/v1/users/me/provider-tokens`;

  list(): Observable<ProviderTokenSlot[]> {
    return this.http.get<ProviderTokenSlot[]>(this.baseUrl);
  }

  upsert(request: ProviderTokenUpsertRequest): Observable<void> {
    return this.http.put<void>(this.baseUrl, request);
  }

  delete(providerType: ProviderType, host: string): Observable<void> {
    const params = new HttpParams().set('providerType', providerType).set('host', host);
    return this.http.delete<void>(this.baseUrl, { params });
  }
}
